import { makeStyles } from '@mui/styles';
import { Box, Button, Grid, Typography, TextField, InputAdornment, IconButton } from '@mui/material';
import { VisibilityOutlined, VisibilityOffOutlined } from '@mui/icons-material';
import { useState, useEffect } from 'react';
import { emailValidator } from '../util/validator';
//import ForgotPassword from '../components/modals/ForgotPassword';
import { useSnackbar } from 'notistack';
import {signInApi} from '../services/authService';
import { AppDomains, consoleToLog, getBackUrl, getServiceName } from '../util/AppUtil';
import CircularProgress from '@mui/material/CircularProgress';
//import { getAuth, signInWithCustomToken } from "firebase/auth";
import { Link, useNavigate } from 'react-router';
import ForgotPasswordModal from '../components/modals/ForgotPasswordModal';
import {useIsMount} from '../components/useIsMount';
import {respectiveAppTitleAndSubtitle} from '../util/AppUtil';
import { fetchAccessToken } from '../util/AppUtil';
import { getQueryParams } from '../util/urlUtil';
import LeftDesignComponent from '../components/LeftDesignComponent';

const useStyles = makeStyles((theme) => ({
    mainContainer: {
        width:'100vw',
        height:'100vh',
        overflow:'auto'
    },
    rightPanelStyle: {
        background:  theme.palette.primary.light,
        height:'100vh',
        display:'flex',
        justifyContent:'center',
        alignItems:'center'
    },
    innerbg: {
        border: "1px solid #dbdbdb",
        borderRadius: "10px",
        padding: "32px 48px",
        background: "#ffffff",
        height:'auto',
        // [theme.breakpoints.down("md")]: {
        //     padding: "45px 20px",
        //     }
    },
    onboardHeading: {
        fontSize : "19px",
        fontWeight: "600",
        margin:'0px auto 8px auto',
    },
    circularProgress: {
        marginLeft: 0,
        marginRight: theme.spacing(2),
        color: 'white'
    },
    registerLink: {
        fontSize:'14px',
        color:'#202020',
        position:'relative',
        top:'8px',
        //textDecoration:'none',
        /* '&:hover': {
            textDecoration:'underline',
        } */
    },
    registerLink1: {
        fontSize:'14px',
        color:'#0000FF',
        position:'relative',
        left:'8px',
        textDecoration:'none',
        '&:hover': {
            textDecoration:'underline',
        }
    },
    registerLink2: {
        fontSize:'14px',
        color:'#007bfb',
        position:'relative',
        left:'8px',
        textDecoration:'none',
        '&:hover': {
            textDecoration:'underline',
        }
    },
    bgImage: {
        backgroundColor: '#f7f7f7 !important'
    }
}));

const LoginPage = (props) => {
    //consoleToLog("Theme vikas: ", props);
    const { enqueueSnackbar } = useSnackbar();
    const navigate = useNavigate();
    const isMount = useIsMount();


        const classes = useStyles();
        const [email, setEmail] = useState('');
        const [password, setPassword] = useState('');
        const [emailInValid, setEmailInValid] = useState(false);
        const [passwordInValid, setPasswordInValid] = useState(false);
        const [buttonLoading, setButtonLoading] = useState(false);
        const [showPassword, setShowPassword] = useState(false);
        
        const [open, setOpen] = useState(false);
        const [serviceName, setServiceName] = useState('');
        const [loading, setLoading] = useState(true);
        const [appTitleAndSubtitle, setAppTitleAndSubtitle] = useState(); 
        const [backUrl, setBackUrl] = useState('');
        const [queryParams, setQueryParams] = useState(getQueryParams(document.location.search));

        const handleClickOpen = () => {
            setOpen(true);
        };

        const handleClose = () => {
            setOpen(false);
        };

        useEffect(()=> {
            // trackGAPageView('/login');
            setLoading(true);
            document.title = props.isAppDomainTyno ? 'Tyno | Login' : 'eProcessify | Login';
            setServiceName(!props.isAppDomainTyno ? queryParams.service : 'tyno');
            setBackUrl(queryParams.back_url);
            const titleSubtitle = respectiveAppTitleAndSubtitle(!props.isAppDomainTyno ? queryParams.service : 'tyno');
            setAppTitleAndSubtitle(titleSubtitle);
        }, []);
        
        useEffect(() => {
                if(!isMount) {
                    const fetchToken = async () => {
                        try {
                        const data = await fetchAccessToken(props.isAppDomainTyno ? 'tyno' : serviceName);
                        if(data) {
                            consoleToLog('Response authenticateApi', data);
                            setLoading(false);
                            const {access_token, redirect_url, invalid_service, scope} = data;
                            const user_scope = scope?.join();
                            if(access_token) {
                                if(redirect_url) {
                                    window.open(`${redirect_url}\?scope=${user_scope}`, '_self');
                                } else if(!redirect_url && !invalid_service) {
                                    navigate(`/not-registered?service=${serviceName}`);
                                } else if(!redirect_url && invalid_service) {
                                    window.open(`${process.env.REACT_APP_INVOICE_DOMAIN_URL}`, '_self');
                                }
                            } else {
                                setLoading(false);
                            } 
                            

                        } 
                        } catch (error) {
                            consoleToLog("error fetchAccessToken", error);
                            setLoading(false);
                        }
                    };
                
                    fetchToken();
            }
        }, [serviceName])

    const onSubmitClick = () => {
        if (!email) {
            setEmailInValid(true);
            return;
        }
        const isEmailValid = emailValidator(email);
        if (!isEmailValid) {
            setEmailInValid(true);
            return;
        }

        if (!password) {
            setPasswordInValid(true);
            return;
        }
        let env = process.env.REACT_APP_DEBUG ? process.env.REACT_APP_ENV : undefined;
        setButtonLoading(true);
        signInApi(email, password, serviceName, env)
            .then((response) => {
                const res = response.data;
                consoleToLog("Response signInApi: ", res);
                setButtonLoading(false);
                const first_login = res?.user.first_login;
                const scope = res.user.scope.join();
                if(res.redirect_url) {
                    enqueueSnackbar('Login Successful', {
                        variant: 'success',
                    });

                    if(queryParams.back_url === 'activate' && queryParams.email) {
                       // navigate(`/${queryParams.back_url}/?${document.location.search.replace(`?back_url=activate&`, '')}`)
                    } else {
                        //window.open(`https://localhost:${props.isAppDomainTyno ? '3001' : '3000'}/?service=${serviceName}&first_login=${first_login}&scope=${scope}${backUrl && backUrl !== '' ? `&back_url=${backUrl}` : ''}`, '_self');
                        window.open(`${res?.redirect_url}&first_login=${first_login}&scope=${scope}${scope}${backUrl && backUrl !== '' ? `&back_url=${backUrl}` : ''}`, '_self');
                    }
                    
                } else {
                    if(res.service) {
                        navigate(`/not-registered?service=${serviceName}`, {state: {access_token: res.access_token, user: res.user}})
                    } else {
                        window.open(`${process.env.REACT_APP_INVOICE_DOMAIN_URL}?service=${serviceName}&first_login=${first_login}&scope=${scope}`, '_self');
                    }
                } 
                
            })
            .catch((e) => {
                consoleToLog("Error signInApi: ", e);
                setButtonLoading(false)
                if(e.response.data && e.response.data.message) {
                    enqueueSnackbar(e.response.data.message, { 
                        variant: 'error',
                    });
                    return false;
                }

                if(e.response.data && e.response.data.detail) {
                    enqueueSnackbar(e.response.data.detail, { 
                        variant: 'error',
                    });
                    return false;
                }
            });
    }

    const handleClickShowPassword = () => {
        setShowPassword(!showPassword);
    };

    const goToRegisterPageOrAllAppsPage = () => {
        return `/register?service=${props.isAppDomainTyno ? 'tyno' : 'invoices'}`;
    }

    return (
            <div className={classes.mainContainer}>
                {loading ?
                <Grid container sx={{justifyContent: 'center', alignItems: 'center'}} style={{marginTop:'18px'}}>
                    <CircularProgress size={28}/>
                </Grid>
                :
                <>
                <Grid container>
                    <LeftDesignComponent appTitleAndSubtitle={appTitleAndSubtitle}
                        isAppDomainTyno={props.isAppDomainTyno}
                    />

                    <Grid size={{md: 8}} className={classes.rightPanelStyle}>
                        <Grid size={{md: 7}}>

                            <Grid size={{md: 12}} style={{marginTop:'32px'}}>

                                <Grid size={{md: 12}} className={classes.innerbg}>
                                    <Typography className={classes.onboardHeading}>
                                        Log in to {props.isAppDomainTyno ? 'Tyno' : 'eProcessify'}
                                    </Typography>

                                    <Typography variant="subtitle1">Enter your credentials to access your account</Typography>

                                    <Grid container direction="column" >
                                        <Grid size={{xs: 12}} style={{marginTop: "15px"}}>
                                            <TextField
                                                    fullWidth
                                                    id="email"
                                                    label="Email"
                                                    type="text"
                                                    variant="outlined"
                                                    size="small"
                                                    margin="dense"
                                                    error={emailInValid}
                                                    helperText={emailInValid ? "* Email is invalid!" : ''}
                                                    onChange={e => {
                                                        setEmail(e.target.value);
                                                        setEmailInValid(false);
                                                    }}
                                                    slotProps={{inputLabel: {style: {fontSize: 14}}}}
                                                />
                                            </Grid>
                                        <Grid container size={{xs: 12}} style={{marginTop: "15px"}}>
                                            <TextField
                                                fullWidth
                                                id="standard-password-input"
                                                label="Password"
                                                type={showPassword ? 'text' : 'password'}
                                                size="small"
                                                margin="dense"
                                                variant="outlined"
                                                onKeyPress={(ev) => {
                                                    //consoleToLog(`Pressed keyCode ${ev.key}`);
                                                    if (ev.key === 'Enter') {
                                                        onSubmitClick();
                                                        ev.preventDefault();
                                                    }
                                                }}
                                                onChange={e => {
                                                    setPassword(e.target.value);
                                                    setPasswordInValid(false);
                                                }}
                                                error={passwordInValid}
                                                helperText={passwordInValid ? "* Password is required!" : ''}
                                                slotProps={{
                                                    inputLabel: {style: {fontSize: 14}},
                                                    input: {
                                                        endAdornment: (
                                                            <InputAdornment position="end">
                                                                <IconButton
                                                                    size='small'
                                                                    aria-label="toggle password visibility"
                                                                    onClick={handleClickShowPassword}
                                                                    edge="end"
                                                                >
                                                                    {showPassword ? <VisibilityOffOutlined fontSize='small'/> : <VisibilityOutlined fontSize='small'/>}
                                                                </IconButton>
                                                            </InputAdornment>
                                                        )
                                                    }
                                                }}
                                            />
                                        </Grid>
                                    </Grid>

                                        <Typography style={{marginTop: "12px", fontSize: "14px", cursor:'pointer'}} 
                                            color="secondary"
                                            className={classes.registerLink2}
                                            onClick={handleClickOpen}
                                        >Forgot your password?
                                        </Typography>

                                    <Grid size={{md: 12}} style={{margin: '24px 0px 16px 0px', textAlign:'center'}}>
                                        <Button variant="contained" color="primary" 
                                            fullWidth
                                            disabled={buttonLoading}
                                            onClick={()=>onSubmitClick()}
                                            >
                                            {buttonLoading && <CircularProgress size={24} className={classes.circularProgress}/>}
                                            Login
                                        </Button>
                                        <div className={classes.registerLink}>
                                            Not registered?
                                            <Link to={goToRegisterPageOrAllAppsPage()} 
                                                className={classes.registerLink1}>
                                                Register
                                            </Link>
                                        </div>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
                {/* :
                <Grid item container justifyContent='center' alignItems='center'
                    style={{backgroundColor: '#f7f7f7 !important', height:'100%'}}
                    className={classes.bgImage}>
                    <img src='/images/404-not-found.png' />
                </Grid> */}
                </>
                }
                {<ForgotPasswordModal isOpen={open} handleClose={handleClose}
                    isAppDomainTyno={props.isAppDomainTyno}
                /> }
            </div>
        )
}

export default LoginPage;